import { Link } from "react-router-dom";

const projects = [
  {
    img: "/assets/projects/project-simon-says.png",
    meta: "Eenmalig · 3u",
    title: "Simon Says Memory-Game",
    text: "LEDs + knoppen + buzzer. Klassieke arcade-memory game.",
    available: true,
  },
  {
    img: "/assets/projects/project-verkeerslicht.png",
    meta: "Eenmalig · 3u",
    title: "Verkeerslicht-systeem",
    text: "3 LEDs + timing-cyclus. Uitbreiding: kruispunt + voetganger-knop.",
    available: false,
  },
  {
    img: "/assets/projects/project-politiesirene.png",
    meta: "Eenmalig · 3u",
    title: "Politiesirene + zwaailichten",
    text: "Rood/blauw flashende LEDs + buzzer voor echte sirene-effecten.",
    available: false,
  },
  {
    img: "/assets/projects/project-quiz-buzzer.png",
    meta: "Eenmalig · 3u",
    title: "Quiz Buzzer",
    text: "Eerste die drukt activeert LED + geluid. Klasquizzen + verjaardagen.",
    available: false,
  },
];

export function Projects() {
  return (
    <section className="bg-alt" id="projecten">
      <div className="container">
        <div className="section-head">
          <span className="section-tag">Projecten</span>
          <h2>Wat bouwen ze precies?</h2>
          <p>
            Elk project eindigt met iets werkend om mee naar huis te nemen. Van beginners tot
            gevorderden.
          </p>
        </div>
        <div className="projects">
          {projects.map((p) => (
            <div className={`proj ${p.available ? "" : "proj-soon"}`} key={p.title}>
              {!p.available && <span className="proj-badge">Nog niet beschikbaar</span>}
              <img src={p.img} alt={p.title} />
              <div className="proj-meta">{p.meta}</div>
              <h4>{p.title}</h4>
              <p>{p.text}</p>
            </div>
          ))}
        </div>
        <div style={{ textAlign: "center", marginTop: 40 }}>
          <Link to="/workshops" className="btn btn-ghost">
            Bekijk alle workshops →
          </Link>
        </div>
      </div>
    </section>
  );
}
